module.exports = __webpack_public_path__ + "static/media/enable-oauth.cdf200db.png";